/* eslint-disable */
export const errors = {
  'Account is not active.': {
    en: 'Account is not active.',
    no: 'Kontoen er ikke aktiv.'
  },
  'Backup token invalid.': {
    en: 'Backup token invalid.',
    no: 'Ugyldig reservepassord.'
  },
  "Can't invest in this pitch.": {
    en: 'You can’t add the investment in this pitch. Contact administrator to receive aid.',
    no: 'Du kan ikke legge inn denne investeringen. Kontakt administrator for å få hjelp.'
  },
  'city: Ensure this field has no more than 30 characters.': {
    en: 'City needs to be up to 30 characters.',
    no: 'Byen må være opptil 30 tegn.'
  },
  "Document for this user doesn't exists": {
    en: 'Document for this user does not exists',
    no: 'Dokument for denne brukeren finnes ikke'
  },
  'Draft pitch can not be featured': {
    en: 'Draft pitch can not be featured.',
    no: 'En kampanjekladd kan ikke publiseres til forsiden'
  },
  'Ensure that there are no more than 2 decimal places': {
    en: 'Ensure that there are no more than 2 decimal places.',
    no: 'Sjekk at det ikke er mer enn 2 desimaler.'
  },
  'Enter a valid email address.': {
    en: 'Enter a valid email address.',
    no: 'Skriv inn en gyldig epost-adresse.'
  },
  'Error retrieving attachment information from pdf': {
    en: 'Error retrieving attachment information from pdf',
    no: 'Feil i henting av informasjon fra vedlegg'
  },
  'Error retrieving attachment from pdf': {
    en: 'Error retrieving attachment from pdf',
    no: 'Feil i henting av vedlegg fra pdf'
  },
  'Failed to generate code.': {
    en: 'Service temporarily unavailable. Use your backup tokens.',
    no: 'Tjenesten er midlertidig nede. Bruk ditt reservepassord.'
  },
  'FileType is in use': {
    en: 'File type is in use',
    no: 'Filen er i bruk'
  },
  'FileType with this tag in use in Self Publish Files': {
    en: 'File type with this tag in use in Self Publish Files',
    no: 'Filen med denne tagen er i bruk i selvpubliseringsfilene'
  },
  'Incorrect email or password': {
    en: 'Incorrect email or password',
    no: 'Feil brukernavn eller passord oppgitt.'
  },
  'Invalid D number': {
    en: 'Invalid D number.',
    no: 'Ugyldig D-nummer.'
  },
  'Invalid GIIN': {
    en: 'Invalid GIIN.',
    no: 'Ugyldig GIIN.'
  },
  'Invalid PNR': {
    en: 'Invalid PNR.',
    no: 'Ugyldig PNR'
  },
  'Invalid UTL': {
    en: 'Invalid UTL.',
    no: 'Ugyldig UTL-nummer.'
  },
  'Investment step not met': {
    en: 'Amount is not multiple of investment step.',
    no: 'Beløpet går ikke opp i investeringssteget.'
  },
  'May pass only one pnr, UTL or D number': {
    en: 'May pass only one pnr, UTL or D number.',
    no: 'Kan kun inneholde ett personnummer, UTL-nummer eller D-nummer.'
  },
  'missing fields': {
    en: 'Missing fields: ',
    no: 'Manglede felter: '
  },
  'signers are not present in Idfy response': {
    en: 'Signers are not present in Idfy response',
    no: 'Idfy finner ikke den som skal signere'
  },
  'ssn is not present in Idfy response': {
    en: 'Ssn is not present in Idfy response',
    no: 'Personnummer er ikke tilgjengelig i svar fra Idfy'
  },
  'The submitted file is empty.': {
    en: 'The submitted file is empty.',
    no: 'Den opplastede filen er tom.'
  },
  'Token invalid.': {
    en: 'Token invalid.',
    no: 'Ugylding token.'
  },
  'User already has added company with this org nr': {
    en: 'Company with this organization number has been already added.',
    no: 'Selskap med dette organisasjonssnummeret er allerede lagt til.uk-icon-trophy'
  },
  "User doesn't have signed document.": {
    en: 'User needs to sign an agreement in order to check his PEP data.',
    no: 'Brukeren må signere avtalen før en PEP-sjekk kan utføres.'
  },
  'user with this email address already exists.': {
    en: 'User with this email address already exists.',
    no: 'Bruker med denne epost-adressen finnes allerede.'
  },
  'User with this pnr already exists.': {
    en: 'User with this PNR already exists.',
    no: 'Bruker med dette personnummeret finnes allerede.'
  },
  "user's pnr already filled": {
    en: "User's pnr already filled",
    no: "User's pnr already filled"
  },
  'Tag in use in Companies': {
    en: 'Tag in use in Companies',
    no: 'Tag er i bruk i Selskaper'
  },
  'Tag: This field must be unique.': {
    en: 'Tag field must be unique.',
    no: 'Tag felt må være unikt.'
  },
  'Wrong path or ElectronicSignature.xml does not exists': {
    en: 'Wrong path or ElectronicSignature.xml does not exists',
    no: 'Feil sti eller ElektonicSignature.xml finnes ikke'
  },
  'You must be over 18 years old to be our customer': {
    en: 'User must be over 18 years old to be our customer.',
    no: 'Brukeren må være over 18 år gammel for å være kunde hos oss.'
  },
  'Rejection reason required if status is bad.': {
    en: 'Before setting status to bad set rejection reason or add description.',
    no: 'Før du setter status til dårlig angi avvisningsårsak eller legg til beskrivelse.'
  },
  'You cannot ask for new pep check, because previous (automatic check) is still valid due to our caching policy. To alter the result create manual pep check or contact administrator.':
    {
      en: 'You cannot ask for new pep check, because previous (automatic check) is still valid due to our caching policy. To alter the result create manual pep check or contact administrator.',
      no: 'Du kan ikke be om en ny pep-sjekk, fordi den forrige (automatiske sjekk) fortsatt er gyldig på grunn av vår caching-policy. For å endre resultatet oppretter du en manuell pep-sjekk eller kontakt administrator.'
    }
};
